import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-24 pb-12 md:pt-32 md:pb-16 px-4 bg-white" data-id="element-79">
      <div className="max-w-4xl mx-auto text-center" data-id="element-80">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-tight mb-6 tracking-tight" data-id="element-81">
          💔 Menos gritos, más conexión con tus hijos
        </h1>

        <div className="relative w-full max-w-2xl mx-auto my-12 cursor-pointer" onClick={scrollToPricing} data-id="element-82">
          <img src="https://cdn.magicpatterns.com/uploads/bsHsKwT54KqnULakoAuxPz/mocap_metodo_calma.png" alt="MÉTODO CALMA® - Megapack Premium - Colección Completa - 6 Tomos + 4 Bonos" className="w-full h-auto" width={672} height={672} fetchPriority="high" loading="eager" data-id="element-83" />
        </div>

        <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-red-600 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-84">
          Descubrí el Método Calma® 👩‍👦 y transformá la forma en que te
          relacionás con tu hijo. Aprendé a manejar los momentos difíciles sin
          gritos, sin culpa y con más conexión real 💞
        </h2>

        <CTAButton text="👉 SÍ, QUIERO ACCEDER AHORA" onClick={scrollToPricing} subtext="Descarga Digital Inmediata • Garantía de satisfacción de 7 días" data-id="element-85" />
      </div>
    </section>;
}